const toCents = (value) => Math.max(0, Math.round(Number(value || 0) * 100))
const fromCents = (value) => Number((Number(value || 0) / 100).toFixed(2))

export const getWaterPurchaseValidation = ({
  amountPaid,
  outstandingDebtAmount = 0,
  rate = 0,
} = {}) => {
  const amountCents = toCents(amountPaid)
  const debtCents = toCents(outstandingDebtAmount)
  const rateCents = toCents(rate)

  if (amountCents <= 0) {
    return {
      isValid: false,
      code: "amount_required",
      debtSettlementAmount: 0,
      purchaseAmount: 0,
      minimumAmount: debtCents > 0 ? fromCents(debtCents) : fromCents(rateCents),
      message: "Please enter a valid water payment amount.",
    }
  }

  if (debtCents > 0 && amountCents < debtCents) {
    return {
      isValid: false,
      code: "full_debt_required",
      debtSettlementAmount: 0,
      purchaseAmount: 0,
      minimumAmount: fromCents(debtCents),
      message: `Please pay the full outstanding water debt of ksh ${fromCents(debtCents).toFixed(2)} first.`,
    }
  }

  const debtSettlementCents = Math.min(amountCents, debtCents)
  const purchaseCents = amountCents - debtSettlementCents
  if (purchaseCents > 0 && rateCents <= 0) {
    return {
      isValid: false,
      code: "rate_required",
      debtSettlementAmount: fromCents(debtSettlementCents),
      purchaseAmount: fromCents(purchaseCents),
      minimumAmount: fromCents(debtCents),
      message: "This property does not have a valid water unit price.",
    }
  }
  if (purchaseCents > 0 && rateCents > 0 && purchaseCents < rateCents) {
    const minimumWithPurchaseCents = debtCents + rateCents
    return {
      isValid: false,
      code: "minimum_purchase_required",
      debtSettlementAmount: fromCents(debtSettlementCents),
      purchaseAmount: fromCents(purchaseCents),
      minimumAmount: fromCents(minimumWithPurchaseCents),
      message: `After clearing the water debt, the remaining amount must buy at least 1 unit. Enter ksh ${fromCents(minimumWithPurchaseCents).toFixed(2)} or pay exactly the debt amount.`,
    }
  }

  return {
    isValid: true,
    code: "valid",
    debtSettlementAmount: fromCents(debtSettlementCents),
    purchaseAmount: fromCents(purchaseCents),
    minimumAmount: debtCents > 0 ? fromCents(debtCents) : fromCents(rateCents),
    message: "",
  }
}
